import React from "react";
import styles from "./content.module.scss";
import { Route, Switch } from "react-router";
import CmsPage from "../Cms/CmsPage";
import CmsCompanyPage from "../Cms/CmsCompany/CmsCompanyPage";
import CmsUser from "../Cms/CmsUser/CmsUser";

const CmsContent = () => {
  return (
    <>
      <Switch>
        <Route exact path={["/cms"]}>
          <div className={styles.container_full}>
            <CmsPage />
          </div>
        </Route>
        <Route exact path={["/cms/companies/:id"]}>
          <div className={styles.container_full}>
            <CmsCompanyPage />
          </div>
        </Route>
        <Route exact path={["/cms/users/:id"]}>
          <div className={styles.container_full}>
            <CmsUser />
          </div>
        </Route>
      </Switch>
    </>
  );
};

export default React.memo(CmsContent);
